import React, { Component } from "react";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import ConsultantContainer from "../../components/agent/consultant/ConsultantContainer";

class AgentConsultant extends Component {
    render() {
        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <ConsultantContainer />
                </MainContainer>
            </main>
        );
    }
}

export default AgentConsultant;
